export default "__VITE_ASSET__otuCtfPl__"